/* eslint-disable consistent-return */
import { formatMinutes } from './utils';

const examNameTranslation = (modality, semester, duration) => {
  if (modality === 'Oral Participation') {
    const text = formatMinutes(duration);
    return {
      name: `Participation orale (${text})`,
      summary: 'Participation en cours d\'année',
      grades: [
        'Prise de parole sollicitée : 5/20',
        'Prise de parole spontanée : 5/20',
        'Présence et implication : 10/20',
      ],
    };
  }
  if (modality === 'Oral - cours en présentiel') {
    const text = formatMinutes(duration);
    return {
      name: `Oral - présentation (${text})`,
      summary: 'Présentation orale',
      grades: [
        'Structure de la présentation : 5/20',
        'Vocabulaire médical : 5/20',
        'Syntaxe et grammaire : 5/20',
        'Contenu, qualité de la présentation : 5/20',
      ],
    };
  }
  if (modality === 'Oral : Role Play') {
    const text = formatMinutes(duration);
    return {
      name: `Oral - jeu de rôle (${text})`,
      summary: 'Présentation orale - role play',
      grades: [
        'Compréhension du contexte : 5/20',
        'Maîtrise de la langue : 5/20',
        'Vocabulaire : 10/20',
      ],
    };
  }
  if (modality === 'Oral : Case study') {
    const text = formatMinutes(duration);
    return {
      name: `Oral - Etude de cas (${text})`,
      summary: 'Présentation orale - étude de cas',
      grades: [
        'Compréhension du contexte : 5/20',
        'Syntaxe et grammaire : 5/20',
        'Vocabulaire médical : 5/20',
        'Qualité de la présentation : 5/20',
      ],
    };
  }
  if (modality === 'Oral : Poster Presentation') {
    const text = formatMinutes(duration);
    return {
      name: `Oral - présentation de poster (${text})`,
      summary: 'Présentation orale - poster',
      grades: [
        'Qualité du poster (clarté du contenu, agencement) : 2.5/20',
        'Qualité de la présentation (pertinence, structure) : 2.5/20',
        'Grammaire et syntaxe : 5/20',
        'Vocabulaire médical : 10/20',
      ],
    };
  }
  if (semester === 3) {
    const text = formatMinutes(duration);
    if (modality === 'Quiz automatisé') {
      return {
        name: `Quiz en ligne (${text})`,
        summary: 'Epreuve de connaissance du vocabulaire professionnel',
        grades: [
          'Compréhension de texte : 20/100',
          'Vocabulaire et termes médicaux : 80/100',
        ],
      };
    }
    if (modality === 'Sur table') {
      return {
        name: `Examen sur table (${text})`,
        summary: 'Epreuve de connaissance du vocabulaire professionnel',
        grades: duration === 60
          ? [
            'Compréhension de texte : 20/80',
            'Vocabulaire et termes médicaux : 60/80',
          ]
          : [
            'Compréhension de texte : 20/100',
            'Vocabulaire et termes médicaux : 80/100',
          ],
      };
    }
  }
  if (semester === 4) {
    const text = formatMinutes(duration);
    if (modality === 'Sur table') {
      return {
        name: `Examen sur table (${text})`,
        summary: 'Traduction d\'un article médical (anglais vers français)',
        grades: [
          'Compréhension globale du texte : 5/20',
          'Précision du vocabulaire médical : 10/20',
          'Syntaxe (temps, groupe verbal...) : 5/20',
        ],
      };
    }
    if (modality === 'Sur la plateforme') {
      return {
        name: `Examen sur la plateforme (${text})`,
        summary: 'Traduction d\'un article médical (anglais vers français)',
        grades: [
          'Compréhension globale du texte : 5/20',
          'Précision du vocabulaire médical : 10/20',
          'Syntaxe (temps, groupe verbal...) : 5/20',
        ],
      };
    }
  }
  if (semester === 5) {
    const text = formatMinutes(duration);
    if (modality === 'Sur table') {
      return {
        name: `Examen sur table (${text})`,
        summary: 'Résumé d\'un article médical',
        grades: [
          'Structure : 3/20',
          'Contenu, idées générales : 5/20',
          'Vocabulaire médical : 10/20',
          'Syntaxe : 2/20',
        ],
      };
    }
    if (modality === 'Sur la plateforme') {
      return {
        name: `Examen sur la plateforme (${text})`,
        summary: 'Résumé d\'un article médical',
        grades: [
          'Structure : 3/20',
          'Contenu, idées générales : 5/20',
          'Vocabulaire médical : 10/20',
          'Syntaxe : 2/20',
        ],
      };
    }
  }
  if (semester === 6) {
    // const text = formatMinutes(duration);
    if (modality === 'Voie postale') {
      return {
        name: 'Examen papier',
        summary: 'Rédaction de l\'abstract du mémoire de fin d\'étude',
        grades: [
          'Méthodologie : 5/20',
          'Mots clé : 2.5/20',
          'Vocabulaire médical : 10/20',
          'Syntaxe : 2.5/20',
        ],
      };
    }
    if (modality === 'Sur la plateforme') {
      return {
        name: 'Examen sur la plateforme',
        summary: 'Rédaction de l\'abstract du mémoire de fin d\'étude',
        grades: [
          'Méthodologie : 5/20',
          'Mots clé : 2.5/20',
          'Vocabulaire médical : 10/20',
          'Syntaxe : 2.5/20',
        ],
      };
    }
  }
};

export default examNameTranslation;
